var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"experts-page"},_vm._l((_vm.experts),function(user){return _c('Expert',{key:user.id,attrs:{"user":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }